// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"2446a064","163":"8ffac71d","200":"633dbbde","252":"76bff71c","410":"ad720435","453":"7a28cdc1","458":"fa577a5d","689":"e6687277","824":"f1342faa","961":"8ecf1231"}[chunkId] + ".chunk.js";
};